/**
 * Wrap images from WP editor in <figure> and remove inline styles
 *
 * Except for gallery items
 */
export default () => {

  if ($('.wysiwyg-content').length) {
    $('.wysiwyg-content figure:not(.gallery-item)').removeAttr('style');

    const $wysiwygImages = $('.wysiwyg-content img').filter(function() {
      return !$(this).parents('figure').hasClass('gallery-item');
    });

    $wysiwygImages.map((index, el) => {

      if ($(el).parent().prop('tagName') !== 'FIGURE') {
        $(el).wrap('<figure class="' + $(el).attr('class') + '"><div class="figure-image-wrapper"></div></figure>').removeAttr('class');
      } else {
        $(el).wrap('<div class="figure-image-wrapper"></div>');
      }

    });
  }

};
